import { createTransport } from "@sentry/core";
import * as Sentry from "@sentry/browser";
// get styles
import "@/css/styles.css";

// get scripts
import "@/js/scripts.js";

// From old gekas
import "@/js/gekas/script.js";
import "@/js/gekas/p2h.script.js";
import "@/js/gekas/script.google-maps.js";

// Search
import "@/js/gekas/search.js";

window.$ = window.jQuery;
window.jQuery = window.jQuery;

function makeFetchTransport(options) {
  function makeRequest(request) {
    const requestOptions = {
      body: request.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: options.headers,
      ...options.fetchOptions,
    };
    return fetch(options.url, requestOptions).then((response) => {
      return {
        statusCode: response.status,
        headers: {
          "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": response.headers.get("Retry-After"),
        },
      };
    });
  }
  return createTransport(options, makeRequest);
}

Sentry.init({
  dsn: "https://2d0c35a357f3c4744a1dbfee38b28589@o515948.ingest.us.sentry.io/4509265289740288",

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  debug: false,
  telemetry: false,
  allowUrls: [/https?:\/\/(?:www\.)?gekas\.se\//],
  transport: makeFetchTransport,
  denyUrls: [
    // Google Analytics URLs
    /google-analytics\.com/i,
    /analytics\.google\.com/i,
    /region1\.google-analytics\.com/i,
    /www\.google-analytics\.com/i,
    /ssl\.google-analytics\.com/i,

    // Cookiebot URLs
    /consentcdn\.cookiebot\.com/i,
    /consent\.cookiebot\.com/i,
    /cookiebot\.com/i,
  ],
  ignoreErrors: [
    // Common Google Analytics errors
    "Script error from Google Analytics",
    /ga has failed/i,
    /google analytics/i,

    // Common Cookiebot errors
    /cookiebot/i,
    /consent/i,
  ],
  beforeSend: (event) => {
    // Check if this error has breadcrumbs with these domains
    if (event.breadcrumbs && event.breadcrumbs.values) {
      const hasBlockedService = event.breadcrumbs.values.some((crumb) => {
        if (crumb.data && crumb.data.url) {
          const url = crumb.data.url;
          return (
            url.includes("google-analytics.com") ||
            url.includes("cookiebot.com")
          );
        }
        return false;
      });

      if (hasBlockedService) {
        return null; // Don't send to Sentry
      }
    }

    // Check if any URLs in the stack trace match these domains
    if (event.exception && event.exception.values) {
      for (const exception of event.exception.values) {
        if (exception.stacktrace && exception.stacktrace.frames) {
          const hasBlockedFrame = exception.stacktrace.frames.some(
            (frame) =>
              frame.filename &&
              (frame.filename.includes("google-analytics.com") ||
                frame.filename.includes("cookiebot.com"))
          );

          if (hasBlockedFrame) {
            return null; // Don't send to Sentry
          }
        }
      }
    }

    return event;
  },

  // Alternatively, use `process.env.npm_package_version` for a dynamic release version
  // if your build tool supports it.
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.captureConsoleIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.httpContextIntegration(),
    Sentry.thirdPartyErrorFilterIntegration({
      // Specify the application keys that you specified in the Sentry bundler plugin
      filterKeys: ["gekas-ullared-mild"],
      behaviour: "drop-error-if-contains-third-party-frames",
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,
  // environment:
  //   process.env.APP_ENV === "development" ? "development" : "production",

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

document.body.addEventListener(
  "error",
  (event) => {
    if (!event.target) return;

    if (event.target.tagName === "LINK") {
      Sentry.captureMessage(
        `Failed to load css: ${event.target.href}`,
        "warning"
      );
    } else if (event.target.tagName === "SCRIPT") {
      Sentry.captureMessage(
        `Failed to load script: ${event.target.src}`,
        "warning"
      );
    }
  },
  true
);

function scrollActiveTabIntoView() {
  const headerHeight = $("#header").height() ? $("#header").height() : 0;
  const adminbarHeight = $("#wpadminbar").height()
    ? $("#wpadminbar").height()
    : 0;
  const activeTab = $(".post-filter__btn.active");

  if (activeTab.length) {
    const y =
      activeTab[0].getBoundingClientRect().top -
      headerHeight -
      adminbarHeight -
      45;

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });

    setTimeout(() => {
      activeTab[0].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }, 800);
  }
}

// Filtering - Blogg + Nyheter
$(".post-filter .post-filter__btn").on("click", function (e) {
  e.preventDefault();

  /* Data */
  let postType = $(this).data("filter");
  let term = $(this).data("term");
  let taxonomy = $(this).data("taxonomy");
  let amountOfPosts = $(this).data("amountOfPosts");
  let showCurrentCatFirst = $(this).data("showCurrentCatFirst");
  let pageurl = $(this).attr("href");

  /* TODO: fix ajaxurl (instead of receiving it from btn attr) */
  let ajax_url = $(".post-filter").data("ajax-url");

  /* Prevent filter on active */
  if ($(this).hasClass("active")) {
    return;
  }

  /* Reset active */
  $(".post-filter__btn").removeClass("active");
  $("#load-more-posts").removeData("searchPostId");
  $("#load-more-posts").removeAttr("data-search-post-id");

  /* Adds active to current */
  $(this).addClass("active");

  $.ajax({
    url: ajax_url,
    type: "GET",
    data: {
      postType: postType,
      term: term,
      taxonomy: taxonomy,
      amountOfPosts: amountOfPosts,
      showCurrentCatFirst: showCurrentCatFirst,
    },
    success: function (response) {
      if (pageurl != window.location) {
        window.history.pushState({ path: pageurl }, "", pageurl);
      }
      if (response.html) {
        $(".post-filter .filter-body").html(response.html);
      } else {
        $(".post-filter .filter-body").html("<p>Inga resultat hittades</p>");
      }

      /* Reset ads_paged */
      ads_paged = 2;

      /* Add crossfunctionality to load more posts */
      if ($("#load-more-posts").length) {
        $("#load-more-posts").data("term", term);
        $("#load-more-posts").data("page", 2);
        $("#load-more-posts").text("Ladda mer");
      }
    },
    error: function (error) {
      $(".post-filter .filter-body").html("<p>Inga resultat hittades</p>");
    },
  });
});

let ads_paged = 2;

/* Load more posts */
$("#load-more-posts").on("click", function (e) {
  e.preventDefault();
  const button = jQuery("#load-more-posts");

  /* TODO: fix ajaxurl (instead of receiving it from btn attr) */
  let ajax_url = button.data("ajax-url");
  let term = button.data("term") || "all";
  let taxonomy = button.data("taxonomy");
  let postType = button.data("filter");
  let offset = button.data("offset");
  let paged = button.data("page");
  let totalLoaded = button.data("totalLoaded") || 0;
  let amountOfPosts = button.data("amountOfPosts");
  let showCurrentCatFirst = $(this).data("showCurrentCatFirst");
  let searchPostId = button.data("searchPostId");

  button.text("Laddar...");

  $.ajax({
    url: ajax_url,
    type: "GET",
    data: {
      postType: postType,
      offset: offset,
      term: term,
      taxonomy: taxonomy,
      paged: paged,
      ads_paged: ads_paged,
      amountOfPosts: amountOfPosts,
      showCurrentCatFirst: showCurrentCatFirst,
      searchPostId: searchPostId,
    },
    success: function (response) {
      if (response.html) {
        $(".post-filter .filter-body").append(response.html);
        button.data("totalLoaded", totalLoaded + response.totalLoaded);
        button.data("page", paged + 1);
        button.text("Ladda mer");

        // ads_paged++;
        ads_paged = response.ads_paged;
      } else {
        button.text("Inga fler inlägg");
      }
    },
    error: function (error) {
      button.text("Inga fler inlägg");
      button.removeClass("loading");
    },
  });
});

/* Open Blog Comments */
$("body").on("click", ".open-blog-comments", function (e) {
  e.preventDefault();
  $(this)
    .parent()
    .closest(".blog-comments-holder")
    .find(".comments-area")
    .slideToggle(200);
});

/* Footer collapse */
$("body").on("click", "footer .collapse-click", function (e) {
  e.preventDefault();
  if (window.innerWidth < 768) {
    $(this)
      .toggleClass("active")
      .parent()
      .closest(".footer-collapse")
      .find(".item")
      .slideToggle(150);
  }
});

/* FAQ Customer Service template */
$(".faq-target").on("click", function (e) {
  $(this).next(".faq-answer").slideToggle(200);
  $(this).parent().toggleClass("active");
});

document.addEventListener("DOMContentLoaded", () => {
  let categoryExistsInUrl = window.location.href.includes("?kategori");
  if (categoryExistsInUrl) {
    scrollActiveTabIntoView();
  }
});

/* Filter Customer Service template */
$(document).ready(function () {
  var hash = window.location.hash;
  if (hash) {
    var slug = hash.replace("#", "");
    jQuery(".cs-filter").each(function () {
      var dataSlug = jQuery(this).data("slug");
      if (
        dataSlug
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/å/g, "a")
          .replace(/ä/g, "a")
          .replace(/ö/g, "o") == slug
      ) {
        jQuery(this).click();
      }
    });
  } else {
    jQuery(".cs-filter").first().click();
  }
});

$(".cs-filter").on("click", function (e) {
  e.preventDefault();
  var index = $(this).index();
  $(".content-holder").hide();
  $(".content-holder").eq(index).show();
  $(".cs-filter").removeClass("active");
  $(this).addClass("active");

  /*
   ** Creates a hash in the URL.
   ** Onload functionality inside template.
   */
  var slug = $(this).data("slug");
  slug = slug
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/å/g, "a")
    .replace(/ä/g, "a")
    .replace(/ö/g, "o");
  var url = window.location.href;
  var newUrl = url.split("#")[0] + "#" + slug;
  window.location.href = newUrl;
});
